import React, { Component } from 'react'
import { Motion, spring, presets } from 'react-motion'
import PropTypes from 'prop-types'

import Calendar from '../components/calendar'
import GroupView from "../components/calendar/group-view"
import DateView from "../components/calendar/date-view"
import CountryView from "../components/calendar/country-view"

import queryString from 'query-string'

const cardenum = { 'comida' : 0, 'jugador' : 1, 'trago' : 2  }

class IndexPage extends Component {

	qsObj = null

	constructor(props) {
	  super(props)
	  this.state = { view: 'fechas', card: 'comida', match: 1, country: 'RUS', scrollTop: 0 }
	  this.gotoview = this.gotoview.bind(this)
	  this.gotocard = this.gotocard.bind(this)
	  this.gotomatch = this.gotomatch.bind(this)
	  this.gotocountry = this.gotocountry.bind(this)
	}

	componentWillMount() {
		const { location } = this.props
		this.qsObj = Object.assign({ vista: 'fechas', partido: 1, ficha: 'comida', pais: 'RUS' }, queryString.parse(location.hash))
		this.setState({ 
			view: typeof this.qsObj.vista !== 'undefined' ? this.qsObj.vista : 'grupos',
			card: typeof this.qsObj.ficha !== 'undefined' ? this.qsObj.ficha : 'comida',			
			country: typeof this.qsObj.pais !== 'undefined' ? this.qsObj.pais : 'RUS',
			match: typeof this.qsObj.partido !== 'undefined' ? this.qsObj.partido : 1
		})

		if (typeof this.qsObj.pais !== 'undefined' && this.qsObj.partido !== 'undefined' && typeof this.qsObj.vista !== 'undefined' && this.qsObj.vista === 'pais') {
			this.getFirstMatch()
		}
	}

	getFirstMatch() {
		const nodes = this.props.data.allDataJson.edges[0].node
		let fMatch = this.qsObj.partido
		let fTeam = nodes.data.matchSchedule.teams.filter(tm => tm.isoalph3 === this.qsObj.pais)
		if (fTeam.length > 0) {
			let team = fTeam[0]
			let tMatchs = nodes.data.matchSchedule.matchs.filter(mt => ((mt.leftTeam.groupId === team.group.id && mt.leftTeam.position === team.group.position) || (mt.rightTeam.groupId === team.group.id && mt.rightTeam.position === team.group.position))).map(mt => mt.id)				
			if (!tMatchs.includes(parseInt(this.qsObj.partido, 0))) {
				fMatch = tMatchs[0]					
				this.setState({ match: fMatch })

				this.qsObj.partido = fMatch
				document.location.hash = queryString.stringify(this.qsObj)
			}				
		}
	}

	gotoview(view) {
		this.setState({ view: view })
		this.qsObj.vista = view
		document.location.hash = queryString.stringify(this.qsObj)
	}

	gotocard(cardIndex) {
		let card = Object.keys(cardenum)[cardIndex]
		this.setState({ card: card })
		this.qsObj.ficha = card
		document.location.hash = queryString.stringify(this.qsObj)
	}

	gotomatch(match) {
		this.setState({ match: match })
		this.qsObj.partido = match
		document.location.hash = queryString.stringify(this.qsObj)	
	}

	gotocountry(country) {
		this.setState({ country: country, view: 'pais' })
		this.qsObj.vista = 'pais'
		this.qsObj.pais = country
		document.location.hash = queryString.stringify(this.qsObj)	

		this.getFirstMatch()
	}

	emphasysCard = (scrollTop) => {
		/*let scroll_top = scrollTop - 100;
		this.setState(prev => { 
				return { scrollTop: scroll_top } 
		});
		console.log({
			scroll_top: scroll_top,
			presets: presets
		});*/
	}

	render() {
		const nodes = this.props.data.allDataJson.edges[0].node
		return (
			<Calendar
				nodes={nodes} 
				location={this.props.location}
				view={this.state.view}				
				cardIndex={cardenum[this.state.card]}
				currentCountryCode={this.state.country}
				currentMatchId={this.state.match}
				gotocountry={this.gotocountry}
				gotocard={this.gotocard}
				gotoview={this.gotoview}
				gotomatch={this.gotomatch}>
				{
					(this.state.view === 'grupos') &&
					<GroupView
						nodes={nodes} 
						currentMatchId={this.state.match}						
						cardIndex={cardenum[this.state.card]}
						gotocard={this.gotocard}
						gotomatch={this.gotomatch}
						emphasysCard={this.emphasysCard}>
					</GroupView>
				}
				{
					(this.state.view === 'fechas') &&
					<DateView
						nodes={nodes}
						currentMatchId={this.state.match}						
						cardIndex={cardenum[this.state.card]}
						gotocard={this.gotocard}
						gotomatch={this.gotomatch}
						emphasysCard={this.emphasysCard}>
					</DateView>
				}
				{
					(this.state.view === 'pais') &&
					<CountryView
						nodes={nodes}
						currentMatchId={this.state.match}						
						cardIndex={cardenum[this.state.card]}
						currentCountryCode={this.state.country}
						gotocard={this.gotocard}
						gotomatch={this.gotomatch}
						emphasysCard={this.emphasysCard}>
					</CountryView>
				}
				<Motion style={{ scrollTop: spring(this.state.scrollTop, presets.wobbly) }}>
                    { currentStyles => { return <WindowScrollSink scrollTop={this.state.scrollTop} /> } }
				</Motion>
			</Calendar> 
		)
	}
}

class WindowScrollSink extends Component {
  componentDidUpdate (prevProps) {
    if (prevProps.scrollTop !== this.props.scrollTop) {
      document.scrollingElement.scrollTop = this.props.scrollTop
    }
  }
  render () { return null }
}

export default IndexPage
export const query = graphql`
query MatchScheduleQuery {
  allDataJson {
    edges {
      node {
        data {
          matchSchedule {
            teams {
              id
              name
              isoalph3
              group {
                id
                position
              }
              flag
              player {
                name
                earnings
                pic
              }
              food {
                name
                calories
                pic
              }
              beverage {
                name
                alcoholProof
                pic
              }
            }
            defaults {
              playerEarnings {
                min
                max
              }
              foodCalories {
                min
                max
              }
              beverageAlcoholProof {
                min
                max
              }
            }
            groups {
              id
              name
            }
            stadiums {
              id
              city
              name
              pic
            }
            dates {
              id
              name
            }
            matchs {
              id
              datetimeUTC
              stadiumId
              dateId
              groupId
              leftTeam {
                groupId
                position
              }
              rightTeam {
                groupId
                position
              }
            }
          }
        }
      }
    }
  }
}
`


// WEBPACK FOOTER //
// ./src/pages/index.js